export default __webpack_public_path__ + "static/media/growth-cycle-animation.0bbd4308.gif";